import React, { useMemo } from 'react';
import { useT } from '@transifex/react';
import { Tooltip } from '@raisin/components-lib';
import { getBankChips } from 'utils/bankPageUtils';

const BankProductChip = ({ bank, distributionChannel }) => {
  const t = useT();

  const bankChips = useMemo(
    () => getBankChips(bank, distributionChannel),
    [bank, distributionChannel],
  );

  return (
    <>
      {bankChips.map((chip) => (
        <Tooltip key={chip.key} content={t(chip.tooltip)}>
          <span>{chip.component}</span>
        </Tooltip>
      ))}
    </>
  );
};

export default BankProductChip;
